<script>
export default {
    props: ["takeChatControl", "messageInput", "isClosed"],
}
</script>

<template>
    <span>
        <div
            class="d-flex align-items-center justify-content-center m-1"
            v-if="isClosed"
        >
            <h6 class="p-0 m-0">
                Chat was closed! You can no longer send any message
            </h6>
        </div>
        <div
            v-else-if="takeChatControl === 0"
            class="d-flex align-items-center justify-content-center btn btn-primary rounded-pill m-1"
            @click="$emit('on-take-control-click')"
        >
            <h6 class="text-white p-0 m-0">Take control of the chat</h6>
        </div>
        <!-- only show this when the chat is under the employer's control -->
        <form v-else @submit.prevent="$emit('on-message-submit')">
            <div class="d-flex align-items-center">
                <!-- add stop control button here -->
                <div
                    class="btn btn-danger round ml-1 font-smaller"
                    @click="$emit('on-stop-control-click')"
                >
                    Stop control
                </div>

                <div class="input-group no-shadow round p-1 w-75">
                    <input
                        :value="messageInput"
                        type="text"
                        class="form-control border-right-0 h-auto"
                        placeholder="Send a message"
                        @input="
                            (event) =>
                                $emit('on-message-input-change', [
                                    event.target.value,
                                ])
                        "
                    />
                    <div class="input-group-append">
                        <input type="file" class="d-none" />
                        <span
                            class="input-group-text upload-btn"
                            @click="$emit('on-upload-btn-click')"
                        >
                            <feather-icon icon="UploadIcon" size="16" />
                        </span>
                    </div>
                </div>

                <button class="btn btn-primary round mr-1" type="submit">
                    Send
                </button>
            </div>
        </form>
    </span>
</template>

<style>
.font-smaller {
    font-size: smaller;
}

.no-shadow {
    box-shadow: none !important;
}
</style>
